import { getShowtimes } from 'utils/bolt/showtimes';

export const CMS_MANAGED_THUNDR_PAGES = ['boltGallery', 'boltHome', 'boltHomeEnt', 'boltPreviewPanel', 'boltShowtimes', 'boltSynopsis', 'boltVideos', 'boltWatchMore'];

// Pages, as shown in any link/page selection dropdown
export function getPages(data) {
	const homeThundrId = data?.content?.pages?.home?.heroType === 'preview' ? 'boltPreviewPanel' : 'boltHome';
	const isDisabled = pageKey => !data?.content?.pages?.[pageKey]?.active;
	return [
		{ id: 'home', destination: homeThundrId, name: 'Home', disabled: false },
		{ id: 'synopsis', destination: 'boltSynopsis', name: 'Synopsis', disabled: isDisabled('synopsis') },
		{ id: 'gallery', destination: 'boltGallery', name: 'Gallery', disabled: isDisabled('gallery') },
		{ id: 'videos', destination: 'boltVideos', name: 'Videos', disabled: isDisabled('videos') },
		{ id: 'showtimes', destination: 'boltShowtimes', name: 'Showtimes', disabled: isDisabled('showtimes') },
		{ id: 'homeEnt', destination: 'boltHomeEnt', name: 'Watch at Home', disabled: isDisabled('homeEnt') },
	];
}

// TODO: double-check names and which items need to be displayed
// Should we also pin the common/famous ones at the top ?
// Should we get this dynamically?
export const HOME_ENT_MERCHANTS = [
	{ slug: 'a24', label: 'A24' },
	// { slug: 'advd', label: 'ADVD' },
	{ slug: 'alamodemand', label: 'Alamo On Demand' },
	// { slug: 'aliveshop', label: 'aliveshop' },
	{ slug: 'all4', label: 'All 4' },
	{ slug: 'altice', label: 'altice' },
	{ slug: 'amazon', label: 'Amazon' },
	// { slug: 'amazon_plain', label: 'Prime Video (plain)' },
	// { slug: 'amazon_prime_rental', label: 'Prime Video (rent)' },
	// { slug: 'amazon_rent_buy', label: 'Prime Video (buy and rent)' },
	// { slug: 'amazonbuyrent', label: 'Amazon (buy and rent)' },
	{ slug: 'amazoninstant', label: 'Amazon Instant Video' },
	// { slug: 'amazonprime', label: 'Prime Video' },
	{ slug: 'amcdemand', label: 'AMC On Demand' },
	{ slug: 'amcplus', label: 'AMC+' },
	// { slug: 'amoeba', label: 'Amoeba Music' },
	{ slug: 'applebuyrent', label: 'Apple TV (buy and rent)' },
	// { slug: 'appletv', label: 'Apple TV' },
	// { slug: 'appletvapp', label: 'Apple TV' },
	// { slug: 'appletvcafr', label: 'Apple TV CA-FR' },
	{ slug: 'appletvplus', label: 'Apple TV+' },
	{ slug: 'argos', label: 'Argos' },
	// { slug: 'atv_logo', label: 'Apple TV' },
	// { slug: 'bamazon', label: 'Amazon' },
	{ slug: 'barnes', label: 'Barnes & Noble' },
	{ slug: 'base', label: 'base.com' },
	{ slug: 'bell', label: 'Bell' },
	{ slug: 'bestbuy', label: 'Best buy' },
	{ slug: 'bfiplayer', label: 'BFI Player' },
	{ slug: 'bleecker', label: 'Bleecker Street' },
	// { slug: 'blockbuster', label: 'Blockbuster' },
	// { slug: 'bmwmedien', label: 'BMV-Medien' },
	{ slug: 'bol', label: 'bol.com' },
	{ slug: 'bt', label: 'BT TV' },
	// { slug: 'bucher', label: 'Bücher' },
	// { slug: 'cablevision', label: 'Cablevision' },
	{ slug: 'canalplayvod', label: 'Canal VOD' },
	{ slug: 'cede', label: 'CeDe.de' },
	{ slug: 'chili', label: 'Chili' },
	{ slug: 'cinebuzz', label: 'cinebuzz' },
	// { slug: 'cineplex', label: 'Cineplex Store' },
	// { slug: 'cineplexcafr', label: 'Cineplex Store (FR)' },
	// { slug: 'cineplexstore', label: 'Cineplex Store' },
	{ slug: 'cogeco', label: 'Cogeco' },
	{ slug: 'comcast', label: 'Comcast' },
	{ slug: 'cox', label: 'Cox' },
	{ slug: 'crackle', label: 'Crackle' },
	{ slug: 'criticschoice', label: 'Critics\' Choice Video' },
	{ slug: 'curzon', label: 'Curzon Home Cinema' },
	{ slug: 'directv', label: 'DIRECTV' },
	{ slug: 'dish', label: 'DISH' },
	{ slug: 'disney-hulu', label: 'Hulu on Disney+' },
	{ slug: 'disneyplus', label: 'Disney+' },
	{ slug: 'dogwoof', label: 'Dogwoof' },
	{ slug: 'ee', label: 'EE TV' },
	{ slug: 'erosnow', label: 'Eros Now' },
	{ slug: 'fandango', label: 'Fandango At Home' },
	// { slug: 'fandango_now', label: 'Fandango NOW' },
	// { slug: 'fandango-bleeck', label: 'Fandango At Home' },
	// { slug: 'fandangoAtHome', label: 'Fandango At Home' },
	// { slug: 'fandangonow', label: 'Fandango NOW' },
	{ slug: 'fetch', label: 'Fetch TV' },
	{ slug: 'filmo', label: 'FILMO' },
	{ slug: 'flixfling', label: 'FlixFling' },
	{ slug: 'fnac', label: 'Fnac' },
	{ slug: 'foxtel', label: 'Foxtel' },
	{ slug: 'frontier', label: 'Frontier' },
	{ slug: 'fubo', label: 'Fubo' },
	{ slug: 'gathr', label: 'Gathr' },
	{ slug: 'gooddocs', label: 'GOOD DOCS' },
	{ slug: 'googlebuyrent', label: 'Google Play (buy and rent)' },
	{ slug: 'googleplay', label: 'Google Play' },
	{ slug: 'gruv', label: 'GRUV' },
	{ slug: 'hbomax', label: 'HBO Max' },
	// { slug: 'HBOmax', label: 'HBO Max' },
	{ slug: 'hidive', label: 'HIDIVE' },
	{ slug: 'hive', label: 'hive.co.uk' },
	{ slug: 'hmv', label: 'HMV' },
	{ slug: 'hoopla', label: 'Hoopla' },
	{ slug: 'hulu', label: 'Hulu' },
	{ slug: 'ifccenter', label: 'IFC Center' },
	{ slug: 'illico', label: 'illico' },
	{ slug: 'imdb', label: 'IMDb TV' },
	// { slug: 'inDemand', label: 'iN DEMAND' },
	{ slug: 'iplayer', label: 'BBC iPlayer' },
	{ slug: 'itunes', label: 'iTunes Store' },
	{ slug: 'itv', label: 'ITV' },
	{ slug: 'jbhifi', label: 'JB Hi-Fi' },
	{ slug: 'jpc', label: 'jpc.de' },
	{ slug: 'kaleidescape', label: 'Kaleidescape' },
	{ slug: 'kanopy', label: 'kanopy' },
	{ slug: 'level', label: 'level FILM' },
	{ slug: 'localnow', label: 'Local Now' },
	{ slug: 'magentatv', label: 'MagentaTV' },
	{ slug: 'magnolia', label: 'Magnolia Selects' },
	{ slug: 'maxdome', label: 'maxdome' },
	{ slug: 'mediamarkt', label: 'MediaMarkt' },
	{ slug: 'mejane', label: 'meJane' },
	{ slug: 'microsoft', label: 'Microsoft' },
	{ slug: 'moviemail', label: 'moviemail' },
	{ slug: 'moviestar', label: 'Movistar Plus+' },
	{ slug: 'mubi', label: 'MUBI' },
	{ slug: 'mueller', label: 'MÜLLER' },
	{ slug: 'musicbox', label: 'Music Box Shop' },
	{ slug: 'neon', label: 'Neon Cinema' },
	{ slug: 'netflix', label: 'Netflix' },
	{ slug: 'nowtv', label: 'Now TV' },
	// { slug: 'nowTV', label: 'Now TV' },
	{ slug: 'ofdb', label: 'OFDb' },
	{ slug: 'optimum', label: 'Optimum' },
	{ slug: 'orange', label: 'Orange' },
	{ slug: 'paramountshowtime', label: 'Paramount+ with Showtime' },
	// { slug: 'pathe', label: 'Pathé' },
	{ slug: 'pathe_home', label: 'Pathé Home' },
	{ slug: 'peacock', label: 'Peacock' },
	{ slug: 'pickx', label: 'Pickx.be' },
	// { slug: 'planet', label: 'Planet of Entertainment' },
	{ slug: 'planetofentertainment', label: 'Planet of Entertainment' },
	{ slug: 'playstation', label: 'PlayStation Store' },
	{ slug: 'plex', label: 'Plex' },
	{ slug: 'pluto', label: 'Pluto TV' },
	// { slug: 'prime-blue', label: 'Prime Video (blue logo)' },
	{ slug: 'primebuy', label: 'Prime Video (buy)' },
	{ slug: 'primerentbuy', label: 'Prime Video (buy and rent)' },
	{ slug: 'primevideo', label: 'Prime Video' },
	{ slug: 'rakuten', label: 'Rakuten TV' },
	{ slug: 'rarewaves', label: 'Rarewaves.com' },
	{ slug: 'redbox', label: 'Redbox' },
	{ slug: 'rogers', label: 'Rogers' },
	{ slug: 'roku', label: 'Roku' },
	{ slug: 'row8', label: 'ROW8' },
	{ slug: 'sanity', label: 'Sanity' },
	{ slug: 'sasktel', label: 'SaskTel' },
	{ slug: 'saturn', label: 'Saturn' },
	{ slug: 'screambox', label: 'Screambox' },
	{ slug: 'sfanytime', label: 'SF Anytime' },
	{ slug: 'shaw', label: 'Shaw' },
	{ slug: 'shout', label: 'Shout Studios' },
	{ slug: 'showcase', label: 'Showcase At Home' },
	{ slug: 'showtime', label: 'Showtime' },
	{ slug: 'shudder', label: 'Shudder' },
	{ slug: 'simply', label: 'Simply Home Entertainment' },
	{ slug: 'sky', label: 'Sky' },
	{ slug: 'skygo', label: 'Sky Go' },
	{ slug: 'skystore', label: 'Sky Store' },
	{ slug: 'sling', label: 'Sling TV' },
	{ slug: 'spectrum', label: 'Spectrum' },
	{ slug: 'strim', label: 'Strim' },
	// { slug: 'talktalk', label: 'TalkTalk TV' },
	{ slug: 'talktalktv', label: 'TalkTalk TV' },
	{ slug: 'target', label: 'Target' },
	{ slug: 'tbs', label: 'TBS' },
	// { slug: 'telekom', label: 'Magenta TV' },
	// { slug: 'telstratv', label: 'Telstra TV' },
	{ slug: 'telus', label: 'Telus' },
	{ slug: 'tesco', label: 'Tesco' },
	{ slug: 'thalia', label: 'Thalia' },
	{ slug: 'thehut', label: 'The Hut' },
	{ slug: 'tiberius', label: 'Tiberius Film' },
	{ slug: 'tnt', label: 'TNT' },
	// { slug: 'TNT', label: 'TNT' },
	{ slug: 'tubi', label: 'tubi' },
	{ slug: 'univers', label: 'UniversCiné' },
	// { slug: 'utopia', label: 'utopia' },
	{ slug: 'verizon', label: 'Verizon' },
	{ slug: 'viaplay', label: 'Viaplay' },
	{ slug: 'videobuster', label: 'Videobuster' },
	{ slug: 'videociety', label: 'Videociety' },
	{ slug: 'videoload', label: 'Videoload' },
	{ slug: 'videotron', label: 'Videotron' },
	{ slug: 'vinegar', label: 'Vinegar Syndrome' },
	// { slug: 'vinegarsyndrome', label: 'Vinegar Syndrome' },
	{ slug: 'virginmedia', label: 'Virgin Media Store' },
	{ slug: 'vodafone', label: 'Vodafone' },
	{ slug: 'voo', label: 'VOO' },
	{ slug: 'vubiquity', label: 'Vubiquity' },
	// { slug: 'vudo', label: 'Vudu' },
	{ slug: 'vudu', label: 'Vudu' },
	// { slug: 'vudufandango', label: 'Vudu Fandango' },
	{ slug: 'walmart', label: 'Walmart' },
	{ slug: 'whsmith', label: 'WHSmith' },
	{ slug: 'xbox', label: 'Xbox' },
	{ slug: 'xfinity', label: 'Xfinity' },
	{ slug: 'xumo', label: 'Xumo' },
	{ slug: 'youtube', label: 'YouTube' },
	{ slug: 'youtubebuy', label: 'YouTube (buy)' },
	{ slug: 'youtuberent', label: 'YouTube (rent)' },
	{ slug: 'youtuberentbuy', label: 'YouTube (buy or rent)' },
	// { slug: 'ytbuyrent', label: 'YouTube (rent/buy)' },
	{ slug: 'zavvi', label: 'Zavvi' },
	// { slug: 'zoom', label: 'zoom.co.uk' },
];

export async function getShowtimesForCMSPreview(showtimesId, geo) {
	if (!showtimesId) {
		return;
	}

	const data = await getShowtimes({
		movie_id: showtimesId,
		lat: geo.lat, lon: geo.lon,
		countries: null,
		// countries: ['US', 'GB'],
		deeplink_providers: 'base:odeon,vue,webedia,pow',
		showtimes_providers: 'base:odeon,vue,webedia,pow',
		filters: {
			// date: [],
		},
	});
	return { data: data.response.data, dates: data.response.filteredFilters?.dates || [] };
}